<form [formGroup]="form.formGroup" class="w-full space-y-2">

  <div class="w-full">
    <label>Type</label>
    <p-select
      class="w-full"
      [options]="loadTypes"
      [formControlName]="form.formControlNames.type"
      optionLabel="name"
      optionValue="value"
      placeholder="Select Load Type"
    ></p-select>
  </div>

  @switch (form.formGroup.value.type) {
    @case (LoadType.RUNINHOLE) {
      <app-run-in-hole-details
        [formControlName]="form.formControlNames.runInHole"
        [userUnits]="userUnits"
        [shoeMd]="shoeMd"
        [hangerMd]="hangerMd"
        [annularFLuidDensity]="annularFLuidDensity"
      ></app-run-in-hole-details>
    }
    @case (LoadType.OVERPULL) {
      <app-overpull-details
        [formControlName]="form.formControlNames.overpull"
        [annularFLuidDensity]="annularFLuidDensity"
        [userUnits]="userUnits"
        [shoeMd]="shoeMd"
        [hangerMd]="hangerMd"
      ></app-overpull-details>
    }
    @case (LoadType.GREENCEMENTTEST) {
      <app-green-cement-test-details
        [formControlName]="form.formControlNames.greenCementTest"
        [userUnits]="userUnits"
        [hangerMd]="hangerMd"
        [shoeMd]="shoeMd"
        [isCemented]="isCemented"
      ></app-green-cement-test-details>
    }
  }

</form>